'use client'

import { useMemo } from 'react'
import { useTranslations } from 'next-intl'

import VisaRenewal from './VisaRenewal/VisaRenewal'
import VisaRenewalSteps from './VisaRenewal/VisaRenewalSteps'
import VisaRenewalNotes from './VisaRenewal/VisaRenewalNotes'
import IkadRenewal from './IkadRenewal/IkadRenewal'
import Tabs, { TabItem } from '@/components/ui/Tabs/Tabs'

export default function RenewalTabs() {
  const t = useTranslations('VisaGuidePage.renewalTabs.tabs')

  const tabsData: TabItem[] = useMemo(() => [
    {
      id: 'visa',
      label: t('visa'),
      content: (
        <>
          <VisaRenewal />
          <VisaRenewalSteps />
          <VisaRenewalNotes />
        </>
      )
    },
    {
      id: 'ikad',
      label: t('ikad'),
      content: <IkadRenewal />
    },
  ], [t])

  return (
    <Tabs
      tabs={tabsData}
      defaultTab="visa"
      ariaLabel="Visa and Medical Renewal Navigation"
    />
  )
}